import { defineComponent as _defineComponent } from 'vue'
import { computed } from 'vue';
  import { EntityTypeProperty } from '@/entities/entityTypeProperty';
  import { ValidationError } from '@/entities/validation';
  import { DropdownField, TagField } from '@/ui/components/form';
  import { SelectOptions } from '@/ui/types';

  interface Props {
    property: EntityTypeProperty;
    modelValue: number[];
    errors?: ValidationError[];
    disabled?: boolean;
  }

  
export default /*#__PURE__*/_defineComponent({
  __name: 'DropdownPropertyInput',
  props: {
    property: {
      type: Object as () => EntityTypeProperty,
      required: true,
    },
    modelValue: {
      type: Array as () => number[],
      required: false,
      default: () => [],
    },
    errors: {
      type: Array as () => ValidationError[],
      required: false,
    },
    disabled: {
      type: Boolean,
      required: false,
      default: false,
    },
  },
  emits: ['input'],
  setup(__props, { emit }) {

const props: Props = __props;

  

  

  const handleInput = (value: number | number[] | null) => {
    emit('input', value);
  };

  const optionValueOptions = computed((): SelectOptions => {
    if (!props.property.optionSet) {
      return [];
    }

    return props.property.optionSet.optionValues
      .filter(option => option.isActive)
      .map(option => ({
        value: option.id!,
        label: option.label,
      }));
  });

  const singleValue = computed(() => {
    return props.modelValue.length > 0 ? props.modelValue[0] : null;
  });

return { __sfc: true,props, emit, handleInput, optionValueOptions, singleValue, DropdownField, TagField }
}

})